<script>
import { useContextStore } from "@/store/context";
import { useMagasinStore } from "@/store/magasin";
import { mapState } from "pinia";
export default {
  computed: {
    ...mapState(useContextStore, ["layout"]),
    ...mapState(useMagasinStore, ["name", "isNational"]),
    component() {
      return defineAsyncComponent(
        lazyComponents[
          `/components/pages/page-not-found-prospectus-produits/${this.layout}.vue`
        ]
      );
    }
  }
};
</script>

<template>
  <component
    :is="component"
    :magasin-name="name"
    :is-national="isNational"
    v-bind="extractListenersFromAttrs($attrs)"
  />
</template>
